<script lang="ts">import { stateUi } from "@infinitro/config";
export let text = "";
export let position = "top";
export let style = {};
export let action = "hover";
export let show = undefined;
$: useAlternative = $stateUi.tooltip.tooltipStyle === "alternative";
$: bgColor = useAlternative ? "var(--color-background-900)" : "var(--color-neutral-900)";
let visible = false;
let triggerEl;
let tooltipLeft = 0;
let tooltipTop = 0;
function computeCoords() {
	if (!triggerEl) return;
	const rect = triggerEl.getBoundingClientRect();
	const offset = 8;
	const bottomOffset = 14;
	switch (position) {
		case "bottom":
			tooltipLeft = rect.left + rect.width / 2;
			tooltipTop = rect.bottom + bottomOffset;
			break;
		case "top":
			tooltipLeft = rect.left + rect.width / 2;
			tooltipTop = rect.top - offset;
			break;
		case "left":
			tooltipLeft = rect.left - offset;
			tooltipTop = rect.top + rect.height / 2;
			break;
		case "right":
			tooltipLeft = rect.right + offset;
			tooltipTop = rect.top + rect.height / 2;
			break;
	}
}
function onShow() {
	if (!text) return;
	computeCoords();
	visible = true;
}
function onHide() {
	visible = false;
}
function onClick() {
	if (visible) onHide();
	else onShow();
}
$: if (show === true) onShow();
$: if (show === false) onHide();
$: transformMap = {
	bottom: "translateX(-50%)",
	top: "translateX(-50%) translateY(-100%)",
	left: "translateX(-100%) translateY(-50%)",
	right: "translateY(-50%)"
};
$: tooltipStyle = [
	`position:fixed`,
	`left:${tooltipLeft}px`,
	`top:${tooltipTop}px`,
	`transform:${transformMap[position]}`,
	`background-color:${bgColor}`,
	`font-size:10px`,
	`border-radius:12px`,
	`padding:8px 16px`,
	`color:#fff`,
	`z-index:9999`,
	`white-space:nowrap`,
	`pointer-events:none`,
	...Object.entries(style).map(([k, v]) => `${k}:${v}`)
].join(";");
</script>

<span
	bind:this={triggerEl}
	class="tooltip-trigger"
	on:mouseenter={action === 'hover' ? onShow : undefined}
	on:mouseleave={action === 'hover' ? onHide : undefined}
	on:click={action === 'click' ? onClick : undefined}
>
	<slot />
</span>

{#if visible && text}
	<div class="tooltip-popup" style={tooltipStyle}>
		{text}
	</div>
{/if}

<style>
	.tooltip-trigger {
		display: inline-block;
	}

	.tooltip-popup {
		animation: tooltip-in 0.2s ease-out;
	}

	@keyframes tooltip-in {
		from {
			opacity: 0;
		}
		to {
			opacity: 1;
		}
	}
</style>
